import script from "./MTB_DropdownModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MTB_DropdownModal.vue?vue&type=script&setup=true&lang=js"

import "./MTB_DropdownModal.vue?vue&type=style&index=0&id=2a22bb18&lang=css"
import "./MTB_DropdownModal.vue?vue&type=style&index=1&id=2a22bb18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a22bb18"]])

export default __exports__